/**
 * Created by tomers on 3/26/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/api-keys/apiDevelopersCommunityView.tmpl");
    var LEResourceResolver = require("leResourceResolver");


    var ApiDevelopersCommunityView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ApiDevelopersCommunityView = Marionette.ItemView.extend({
            className: "api-developers-community-view",
            template: template,
            ui: {

            },
            uiComponents: {

            },
            events: {
                "click": "_onClick"
            },

            _onClick: function() {
                var developersCommunityUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.LivepersonInc.Site);
                LE.navigator.open(developersCommunityUrl, "developers_community");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ApiDevelopersCommunityView;

});
